import { FC, useEffect } from 'react';

import useMap from 'hooks/use-map';

interface IConfirmRestaurantMapProps {
  lat: number;
  lng: number;
}

export const ConfirmRestaurantMap: FC<IConfirmRestaurantMapProps> = ({ lat, lng }) => {
  const { map, createMarker, MarkerTypes } = useMap({
    position: { lat, lng },
    disableControls: true,
  });

  useEffect(() => {
    createMarker({ type: MarkerTypes.Store, location: { lat, lng }, introAnim: true });
  }, [MarkerTypes.Store, createMarker, lat, lng]);

  return map;
};
